import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"


import {
  postJwtForgetPwd,
} from "../../../helpers/auth_helper";

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
      let response;
      response = postJwtForgetPwd(user.email);
      const data = await response;

      if (data) {
          dispatch(userForgetPasswordSuccess(
              "Reset link are sended to your mailbox, check there first"
          ))
      }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}
